import { signal } from "@angular/core";
import { debounce, SchemaPathTree, validate } from "@angular/forms/signals";
const DEFAULT_MAX_TEXT_VALUE = "∞";
const DEFAULT_MIN_TEXT_VALUE = "";

const defaultSqmMaxPrice = 50000;
const defaultSqmMinPrice = 0;

export interface PlotAreaFilterModel {
    plotAreaFrom: string | null;
    plotAreaTo: string | null;
    expanded: boolean;
}

export function createPlotAreaModel() {
    return signal<PlotAreaFilterModel>({
        plotAreaFrom: DEFAULT_MIN_TEXT_VALUE,
        plotAreaTo: DEFAULT_MAX_TEXT_VALUE,
        expanded: false,
    });
}

export function buildPlotAreaModel(a: SchemaPathTree<PlotAreaFilterModel>) {
    debounce(a.plotAreaFrom, 300);
    debounce(a.plotAreaTo, 300);
    maxPriceValidator(a.plotAreaTo);
    minPriceValidator(a.plotAreaFrom, a.plotAreaTo);
}

function maxPriceValidator(field: any) {
    validate(field, ({ value }) => {
        const maxPrice = value();
        if (defaultSqmMinPrice != null && +maxPrice < defaultSqmMinPrice) {
            return {
                kind: "belowLimit",
                message: `Fra-verdi er lavere enn tillatt minsteverdi (${defaultSqmMinPrice}).`,
            };
        } else if (defaultSqmMaxPrice != null && +maxPrice > defaultSqmMaxPrice) {
            return {
                kind: "aboveLimit",
                message: `Til-verdi er høyere enn tillatt maksverdi (${defaultSqmMaxPrice}).`,
            };
        }
        return null;
    });
}

function minPriceValidator(field: any, validateAgainstField?: any) {
    validate(field, ({ value, valueOf }) => {
        let minPrice = value();
        let maxPrice = valueOf(validateAgainstField);
        if (defaultSqmMinPrice != null && +minPrice < defaultSqmMinPrice) {
            return {
                kind: "belowLimit",
                message: `Fra-verdi er lavere enn tillatt minsteverdi (${defaultSqmMinPrice}).`,
            };
        } else if (defaultSqmMaxPrice != null && +minPrice > defaultSqmMaxPrice) {
            return {
                kind: "aboveLimit",
                message: `Til-verdi er høyere enn tillatt maksverdi (${defaultSqmMaxPrice}).`,
            };
        } else if (maxPrice != null && maxPrice != "" && +minPrice > +maxPrice) {
            return {
                kind: "aboveMax",
                message: "Fra-verdi er høyere enn Til-verdi.",
            };
        }
        return null;
    });
}
